var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('ContractResolver',{attrs:{"global":_vm.global}}),_c('ContractRequest',{attrs:{"global":_vm.global}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }